import React from 'react';
import {Button} from "semantic-ui-react";

const BannerCalc = ({}) => {
    const click = () => {
        const els = document.getElementsByClassName('b24-widget-button-inner-container');
        (els && els[0]) && els[0].click()
    }

    return (
        <div className='calc-banner'>
            <img src="/img/calcbanner.png" height={351} width={232} alt="loading"/>
            <Button onClick={click} className='calc-banner__btn'>Написать</Button>
        </div>
    );
};

export default BannerCalc;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/bannerCalc.jsx